// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/DesignBuild.tsx

import HeroParallax from "../../components/HeroParallax.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const DesignBuild = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.design-build.title")}
        titleLink="#services"
        items={[      
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },    
          { id: "2", label: t("anchor.whatWeDo"), anchor: "AllServices" },          
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },     
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },    
          
        ]}
      />

      

      <section id="Services">
      <HeroParallax        
        header={t("services.design-build.header")}
        welcome={t("services.design-build.welcome")}
        title={t("services.design-build.description.short")}
        description={t("services.design-build.description.long")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-1249978410.jpg"
      />
    </section>

      <section id="Counter">
      <Counter 
        items={[
          {
            key: "buildingPeriod",
            endValue: 30,
            prefix: "-",
            suffix: "%",
          },
          {
            key: "buildingVolume",
            endValue: 100,
            prefix: "",
            suffix: " Mio.€",
          },
          {
            key: "realizedProjects",
            endValue: 200,
            prefix: "",
            suffix: "+",
          },
          {
            key: "realizedSquareMeters",
            endValue: 75000,
            prefix: "",
            suffix: "+",
          },
        ]}
        sectionTitle={t("services.design-build.title")}
        mainTitle={t("counter.heading.title")}
      />
      </section>

      

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.design-build.title"),
            title: t("services.design-build.header"),
            explore: t("services.design-build.explore"),
          }}        
          items={[   
            {
              id: 1,
              title: t("services.construction-services.title"),
              subtitle: t("services.construction-services.description.short"),
              description: t("services.construction-services.description.long"),
              link: "/services/construction-services",
            },         
            {
              id: 2,
              title: t("services.general-planning.title"),
              subtitle: t("services.general-planning.description.short"),
              description: t("services.general-planning.description.long"),
              link: "/services/general-planning",
            },            
            {
              id: 3,
              title: t("services.workplace-consulting.title"),
              subtitle: t("services.workplace-consulting.description.short"),
              description: t("services.workplace-consulting.description.long"),
              link: "/services/workplace-consulting",
            },
            {
              id: 4,
              title: t("services.estata-retail.title"),
              subtitle: t("services.estata-retail.description.short"),
              description: t("services.estata-retail.description.long"),
              link: "/services/estata-retail",
            },
            {
              id: 5,
              title: t("services.estata-commercial.title"),
              subtitle: t("services.estata-commercial.description.short"),
              description: t("services.estata-commercial.description.long"),
              link: "/services/estata-commercial",
            },
            {
              id: 6,
              title: t("services.estata-residental.title"),
              subtitle: t("services.estata-residental.description.short"),
              description: t("services.estata-residental.description.long"),
              link: "/services/estata-residental",
            },
            {
              id: 7,
              title: t("services.design-build-repeat.title"),
              subtitle: t("services.design-build-repeat.description.short"),
              description: t("services.design-build-repeat.description.long"),
              link: "",
            },
            {
              id: 8,
              title: t("services.fire-protection.title"),
              subtitle: t("services.fire-protection.description.short"),
              description: t("services.fire-protection.description.long"),
              link: "/services/fire-protection",
            },
          ]}        
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.design-build.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["AS"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),    
            description: t("home.esg.heading.description"),       
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },          
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },          
          ]}
        />
      </section>

      
    </>
  );
};

export default DesignBuild;